<template>
  <div>
    <el-form label-position="top" :model="form" :rules="rules" ref="form">
      <el-form-item :label="dutypersontable.displayname+(dutypersontable.fieldtip?'('+dutypersontable.fieldtip+')':'')||''" prop="dutyperson">
        <el-input v-model="form.dutyperson" :placeholder="dutypersontable.placecontent||''" clearable></el-input>
        <yincan :content="dutypersontable.inputtip"></yincan>
      </el-form-item>

      <el-form-item :label="dutypersonphonetable.displayname+(dutypersonphonetable.fieldtip?'('+dutypersonphonetable.fieldtip+')':'')||''" prop="dutypersonphone">
        <el-input v-model="form.dutypersonphone" :placeholder="dutypersonphonetable.placecontent||''" clearable></el-input>
        <yincan :content="dutypersonphonetable.inputtip"></yincan>
      </el-form-item>

	  <el-form-item :label="dutypersonmajortable.displayname+(dutypersonmajortable.fieldtip?'('+dutypersonmajortable.fieldtip+')':'')||''" prop="dutypersonmajor">
	    <el-input v-model="form.dutypersonmajor" :placeholder="dutypersonmajortable.placecontent||''" clearable></el-input>
		  <yincan :content="dutypersonmajortable.inputtip"></yincan>
	  </el-form-item>

      <div class="teamMember">
        <div class="teamMember-head">
          <div>{{ teamper.displayname+(teamper.fieldtip?'('+teamper.fieldtip+')':'')||'' }}</div>
          <el-link class="teamMemberAddLink" type="success" @click="addTeam">添加</el-link>
        </div>
        <div>
          <el-form :model="teams" :rules="teamRules" ref="teams" class="teamMemberInput" v-for="(v,i) in teams.teamsList" :key="i">
            <el-form-item label="" :prop="'teamsList.'+i+'.name'" :rules="teamRules.name">
              <el-input v-model="v.name" placeholder="姓名" clearable></el-input>
            </el-form-item>
            <el-form-item class="inputTwo" label="" :prop="'teamsList.'+i+'.phone'" :rules="teamRules.phone">
              <el-input v-model="v.phone" placeholder="电话" clearable></el-input>
            </el-form-item>
            <el-form-item class="inputTwo" label="" :prop="'teamsList.'+i+'.major'" :rules="teamRules.major">
              <el-input v-model="v.major" placeholder="专业" clearable></el-input>
            </el-form-item>
            <div class="teamMemberBtns">
              <!-- <el-link type="info" @click="upDateTeam(v,i)">保存</el-link> -->
			        <div style="width: 28px;" v-if="i==0"></div>
              <el-link type="danger" @click="deleteTeam(v,i)" style="white-space: nowrap;" v-if="i!=0">删除</el-link>
            </div>
          </el-form>
        </div>
        <yincan :content="teamper.inputtip"></yincan>
      </div>

      <el-form-item :label="addresstable.displayname+(addresstable.fieldtip?'('+addresstable.fieldtip+')':'')||''" prop="address">
        <el-input v-model="form.address" :placeholder="addresstable.placecontent||''" clearable></el-input>
        <yincan :content="addresstable.inputtip"></yincan>
      </el-form-item>

      <el-form-item :label="introduceytable.displayname+(introduceytable.fieldtip?'('+introduceytable.fieldtip+')':'')||''" clearable prop="introduce">
        <!-- <tinymce-editor v-model="form.introduce"></tinymce-editor> -->
        <el-input
          type="textarea"
          :placeholder="introduceytable.placecontent||''"
          :maxlength="introduceytable.len"
          v-model="form.introduce"
          rows="6">
        </el-input>
        <yincan :content="introduceytable.inputtip"/>
      </el-form-item>
    </el-form>
    <bottomButtons @childrenDoPre="childrenDoPre" @childrenDoNext="childrenDoNext" />
  </div>
</template>
<script>
import TinymceEditor from "../../../components/tinymce-editor.vue";
import bottomButtons from "../../../components/bottomButtons.vue";
import yincan from "../../../components/yincan.vue";
import {
  saveProject,
  getProjectMember,
  saveProjectMmeber,
  delProjectMember,
  getProjectType
} from "../../../api/signUp";
import { validPhone } from "../../../validate/common";
import res from "../../../utils/msg";
const addTeams = {
  name: "",
  phone: "",
};
export default {
  components: {
    bottomButtons,
    TinymceEditor,
    yincan
  },
  data() {
    return {
		typechoose:'',
		cinum:1,
      form: {
        iscg: 1,
        project_id: "", // 项目 id
        school: "", // 学校名称
        team: "", // 团队
        name: "", // 项目名称
        project_type_ids: "", // 项目类型
        teacher: "", // 指导老师
        teacherphone: "", // 老师联系方式
        dutyperson: "", // 项目负责人
        dutypersonphone: "", // 项目负责人联系方式
        address: "", // 通讯地址
        introduce: "", // 项目简介
        innovate: "", // 项目创新点
        activitytime: "", // 活动时间
        activityaddress: "", // 活动地点
        activityobject: "", // 活动对象
        step: "", // 步骤
        risk: "", // 项目风险
        target: "", // 预期目标
        // 成员列表
        teams: [
          {
            name: "",
            phone: "",
			major:''
          },
        ],
      },
      teams: {
        teamsList: [
          {
            name: "",
            phone: "",
			      major:''
          },
          {
            name: "",
            phone: "",
			      major:''
          },
        ],
      },
      teamRules: {
        name: [
          { required: true, message: " ", trigger: "blur" },
        ],
        phone: [
          {
            trigger: "blur",
            // validator: validPhone,
          },
        ],
      },
      rules: {
        dutyperson: [
          { required: true, message: " ", trigger: "blur" },
        ],
        dutypersonphone: [
          { required: true, trigger: "blur" },
        ],
        address: [
          { required: true, message: " ", trigger: "blur" },
        ],
        introduce: [
          { required: true, message: " ", trigger: "blur" },
        ],
      },
      dutypersontable: {},//项目负责人
      dutypersonphonetable:{},//项目负责人联系方式
      dutypersonmajortable:{},//项目负责人专业
      teamper:{},//团队成员
      addresstable:{},//通讯地址
      introduceytable:{},//项目简介
    };
  },
  // watch:{
	 //  'form.introduce':{
		//   handler(newval){
		// 	  if(this.cinum==2){
		// 		 if(this.form?.introduce?.trim().length>=this.introduceytable.len){
		// 		 	res.error("最多只能输入" + this.introduceytable.len + "个字");
		// 			this.form.introduce = this.form.introduce
		// 		 }
		// 	  }else{
		// 			 this.cinum=2
		// 		} 
		//   },
		//   deep:true,
		//   immediate: true
	 //  }
  // },
  mounted() {
  	this.gettype()
    setTimeout(() => {
				this.getLable()
			}, 1500);
  },
  methods: {
    getLable(){
      this.dutypersontable = this.$store.state?.hintText.hintText.data.find(item => item.fieldcode == 'dutyperson')
      this.dutypersonphonetable = this.$store.state?.hintText.hintText.data.find(item => item.fieldcode == 'dutypersonphone')
      this.dutypersonmajortable = this.$store.state?.hintText.hintText.data.find(item => item.fieldcode == 'dutypersonmajor')
      this.teamper = this.$store.state?.hintText.hintText.data.find(item => item.fieldcode == 'teamper')
      this.addresstable = this.$store.state?.hintText.hintText.data.find(item => item.fieldcode == 'address')
      this.introduceytable = this.$store.state?.hintText.hintText.data.find(item => item.fieldcode == 'introduce')
    },
	gettype(){
		getProjectType().then(res=>{
			this.typechoose = res.data.value
		})
	},
    getFather_step2(data) {
      this.form = data;
      // 查询团队列表
      this.getTeamList();
    },
    childrenDoPre() {
      this.$parent.doPre();
    },
    /**
     * 添加团队成员
     */
    addTeam() {
      if(this.teams.teamsList.length>=9){
        res.error("团队成员最多为9个");
        return
      }
      this.teams.teamsList.push({ ...addTeams });
    },
    /**
     * 保存团队成员
     */
    // upDateTeam(v, i) {
    //   const _this = this;
    //   _this.$refs.teams[i].validate(async (valid) => {
    //     if (valid) {
    //       if (v.id) {
    //         let _data = {
    //           project_id: this.form.project_id,
    //           ...v,
    //         };
    //         try {
    //           let updateRes = await saveProjectMmeber(_data);
    //           if (updateRes.data.code == 1) {
    //             res.success(updateRes.data.msg);
    //             await this.getTeamList();
    //           } else {
    //             res.error(updateRes.data.msg);
    //           }
    //         } catch (error) {
    //           // console.log(error);
    //         }
    //       } else {
    //         let _data = {
    //           project_id: this.form.project_id,
    //           ...v,
    //         };
    //         try {
    //           let saveRes = await saveProjectMmeber(_data);
    //           console.log(saveRes, "添加预算");
    //           if (saveRes.data.code == 1) {
    //             res.success(saveRes.data.msg);
    //             await this.getTeamList();
    //           } else {
    //             res.error(saveRes.data.msg);
    //           }
    //         } catch (error) {
    //           // console.log(error);
    //         }
    //       }
    //     }
    //   });
    // },
    /**
     * 删除团队成员
     */
    async deleteTeam(v, i) {
      if (v.id) {
        let _data = {
          id: v.id,
        };
        try {
          let deleteRes = await delProjectMember(_data);
          if (deleteRes.data.code == 1) {
            res.success(deleteRes.data.msg);
            await this.getTeamList();
          } else {
            res.error(deleteRes.data.msg);
            await this.getTeamList();
          }
        } catch (error) {
          // console.log(error);
        }
      } else {
        this.teams.teamsList.forEach((v1, i1) => {
          if (i1 == i) {
            this.teams.teamsList.splice(i1, 1);
          }
        });
      }
    },
    /**
     * 查询团队列表
     */
    async getTeamList() {
      let _data = {
        project_id: this.form.project_id||this.form.id,
      };
      try {
        let findRes = await getProjectMember(_data);
        console.log(findRes, "查询团队列表");
        if (findRes.data.code == 1) {
			if(findRes.data.data==''||!findRes.data.data||findRes.data.data.length==0){
				// this.teams.teamsList=this.teams
			}else{
				this.teams.teamsList = findRes.data.data;
			}
        }
      } catch (error) {
        console.log(error);
      }
    },

    savememberfn(){
        if(this.teams.teamsList.length>0){
					  let flag = this.teams.teamsList.every(v=>{
						  return v.name && v.phone &&v.major
					  });
					  if(!flag){
              this.$message.error("请补全成员信息");
						  return false;
					  };
					  for(var i =0;i<this.teams.teamsList.length;i++){
              this.teams.teamsList[i].project_id = this.form.project_id||this.form.id;
						  saveProjectMmeber(this.teams.teamsList[i]).then(resone => {
						  	if (resone.data.code == 1) {
								  this.getTeamList()
						  	}else{
								  this.$message.error(resone.data.msg)
							}
						  })
					  }
					  return true;
				  }else{
            this.$message.error("请补全成员信息");
						return false;
				  }
		},

    async childrenDoNext() {
      const _this = this;
	  if(_this.teams.teamsList.length<2){
		  _this.$message({
		            message: '项目团员不能少于2人',
		            type: 'warning'
		          });
		  return
	  }
	  if(!this.form.introduce){
		  _this.$message({
		            message: '项目简介不能为空',
		            type: 'warning'
		          });
				  return
	  }
      const saveResult = this.savememberfn();
      if (!saveResult) {
        return;
      }
      _this.$refs.form.validate(async (valid) => {
        if (valid) {
          let _data = {
            ..._this.form,
            project_id: _this.form.project_id||_this.form.id,
          };
          // 把 project_type_id 转为逗号分隔的字符串
          if(this.typechoose==1){
          			let newProjectTypeStrs = "";
          			for (const v of _data.project_type_ids) {
          			  newProjectTypeStrs += v + ",";
          			}
          			newProjectTypeStrs = newProjectTypeStrs.substring(
          			  0,
          			  newProjectTypeStrs.length - 1
          			);
          			_data.project_type_ids = newProjectTypeStrs;  
          }
          try {
            let saveRes = await saveProject(_data);
            if (saveRes.data.code == 1) {
              this.$message.success('更新成功');
              _this.$parent.doNext();
            } else {
              this.$message.error(saveRes.data.msg);
            }
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.teamMember {
  .teamMember-head {
    line-height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: #606266;
  }
}
.teamMemberInput {
  display: flex;
  align-items: center;
}
.fz-FF0000{
	font-size: 14px;
	color: #FF0000;
}
.inputTwo {
  margin-left: 30px;
}
.teamMemberBtns {
  flex: 1;
  padding-left: 60px;
  width: 100px;
  margin-bottom: 22px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.addjia{
		display: -webkit-box;
		 -webkit-line-clamp: 1;
		 -webkit-box-orient: vertical;
		 overflow: hidden;
		 text-overflow: ellipsis;
		 line-height: 1.5em;
		 max-height: 3em;
	}
	.addjian{
		-webkit-line-clamp: 10 !important;
		max-height: 100em !important;
	}
	.fz-409EFF{
		color: #409EFF;
	}
</style>
